<template>
    <div>
        <h3 class="title is-3">Documents</h3>
        <hr />
        <Document/>
    </div>
</template>

<script>
import Document from '@/components/Document/Document.vue'

export default {
    components:{
        Document
    }
}
</script>
